<div class="item">
  <div class="item__flex-block">
    <div *ngIf="icon" class="item__icon">
      <app-icon [src]="icon"></app-icon>
    </div>

    <span class="item__label text_size-m">{{ label }}</span>
  </div>

  <div *ngIf="actions" class="item__actions">
    <app-actions [mode]="'icons'" [items]="actions"></app-actions>
  </div>
</div>
